/**
 * Community utility functions
 * Manages community_id from various sources
 */

const DEV_HOSTNAMES = ["localhost", "127.0.0.1", "0.0.0.0"];

export const getCommunityId = () => {
  // Priority: LocalStorage > Environment Variable > Default
  const fromStorage = localStorage.getItem("communityId");
  if (fromStorage) return parseInt(fromStorage);

  const fromEnv = process.env.REACT_APP_COMMUNITY_ID;
  if (fromEnv) return parseInt(fromEnv);

  return 1; // Default community ID
};

export const setCommunityId = (communityId) => {
  localStorage.setItem("communityId", communityId.toString());
};

export const clearCommunityId = () => {
  localStorage.removeItem("communityId");
};

/**
 * Resolve community from hostname and store in localStorage.
 * - Dev (localhost): falls back to REACT_APP_COMMUNITY_ID or 1
 * - Production: calls GET /api/community/resolve?domain={hostname}
 * Returns the resolved community ID.
 */
export const resolveAndSetCommunityFromDomain = async () => {
  const hostname = window.location.hostname;

  // Dev environment — use env var or default
  if (DEV_HOSTNAMES.includes(hostname)) {
    const id = parseInt(process.env.REACT_APP_COMMUNITY_ID) || 1;
    setCommunityId(id);
    return id;
  }

  // Production — resolve via backend
  try {
    const apiUrl = process.env.REACT_APP_API_URL || "";
    const res = await fetch(`${apiUrl}/api/community/resolve?domain=${encodeURIComponent(hostname)}`);
    if (res.ok) {
      const data = await res.json();
      const id = data.communityId || 1;
      setCommunityId(id);
      return id;
    }
  } catch (err) {
    console.error("Failed to resolve community from domain:", err);
  }

  // Fallback
  const fallback = parseInt(process.env.REACT_APP_COMMUNITY_ID) || 1;
  setCommunityId(fallback);
  return fallback;
};

export const isSuperAdmin = (role) => {
  return role === "super admin";
};

export const isRCRProjectManager = (role) => {
  return role === "rcr project manager";
};

export const canManageCommunity = (role) => {
  return isSuperAdmin(role) || isRCRProjectManager(role);
};

export const canAccessSuperAdminDashboard = (role) => {
  return isSuperAdmin(role);
};
